import { l10n } from '@ott/l10n';

import { FORM_FIELDS } from './constants';

import * as Yup from 'yup';

const PHONE_MIN_LENGTH = 6;
const PHONE_MAX_LENGTH = 11;

const incorrectPhoneError = l10n('virtualCard.releaseForm.errors.incorrectPhone');

export const getValidationSchema = ({ isPinSent }: { isPinSent: boolean }) =>
  Yup.object({
    [FORM_FIELDS.PHONE]: Yup.string()
      .min(PHONE_MIN_LENGTH, incorrectPhoneError)
      .max(PHONE_MAX_LENGTH, incorrectPhoneError)
      .matches(/^(?:79).*$/, incorrectPhoneError),
    [FORM_FIELDS.PIN]: isPinSent ? Yup.string().required(l10n('required.required')) : Yup.string(),
  });
